//import initHttp from "./api/client";

/**
 * available env variable definition
 */
export interface AppConfig {
  TEST_KEY: string;
  API_URL: string;
  USERBACK_TOKEN: string;
  ENABLE_LEAVE_MANAGEMENT: boolean;
  ENABLE_LANGUAGE_SWITCHER: boolean;
  PROVINCE_DEMO_ENABLED: boolean;
  ENABLE_ANNOUNCEMENT: boolean;
  ENABLE_SENTRY: boolean;
  ENABLE_BRANCH_BETA: boolean;
  ENVIRONMENT: string;
  ENABLE_ASSET_V2_BETA: boolean;
  /** Formation / Training nav items, until the module ships (spec D119). */
  ENABLE_TRAINING?: boolean;
  /** External trainings and the spend ledger (PR 4.5), staging first. */
  ENABLE_TRAINING_SPEND?: boolean;
  /** The Quebec 1% law report under Training > Spend (PR 4.6). */
  ENABLE_TRAINING_QC_REPORT?: boolean;
  /** Payroll page (export, settings, codes) until payroll v1 ships (PR 5). */
  ENABLE_PAYROLL_EXPORT?: boolean;
  EMPLOYEE_PORTAL_URL: string;
  COMPANY_PORTAL_URL?: string;
  CHATBOT_URL: string;
  ENABLE_TOUR: boolean;
  ENABLE_MCP_CONNECTOR?: boolean;
  /** Public marketing website, which hosts the careers pages (`/career/...`). */
  PUBLIC_WEBSITE_URL?: string;
  /**
   * Cloudflare Turnstile site key (public). Empty: the signup form shows no
   * challenge. Set it together with the backend's SIGNUP_TURNSTILE_ENABLED.
   */
  TURNSTILE_SITE_KEY?: string;
}

let CFG: AppConfig | null = null;

/**
 * Loads the config object from ./config/config.json.
 * If the config object is already loaded, it returns the cached config object.
 * If the config object hasn't been loaded before calling this function,
 * it will fetch the config object from ./config/config.json and cache it.
 * If the fetch fails, an error will be thrown.
 * @returns {Promise<AppConfig>} - The config object.
 */
export async function loadRuntimeConfig() {
  if (CFG) return CFG;

  // /config/config.json will be created at container start (or provided locally)
  const res = await fetch('/config/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error('Failed to load config');
  CFG = (await res.json()) as AppConfig;
  _initializePreReq();
  return CFG;
}

/**
 * Returns the config object that was loaded from ./config/config.json.
 * If loadRuntimeConfig() hasn't been called before calling this function,
 * an error will be thrown.
 * @returns {AppConfig} - The config object.
 * @throws {Error} - If loadRuntimeConfig() hasn't been called before calling this function.
 */
export function getConfig(): AppConfig {
  if (!CFG)
    throw new Error('Config not loaded. Call loadRuntimeConfig() first.');
  return CFG;
}

function _initializePreReq() {
  // initHttp();
}
